<template>
    <div class="background-images">
       
        <div v-for="(o, index) in $store.state.productInfo.backgroundimages"
             :key="o.backgroundImageId"
             :data-index="index"
             v-on:click="changeBackgroundImage(o.backgroundImageId, o.backgroundImageUrl)"
             v-bind:class="['background-image', { selected: o.backgroundImageId == selectedbackgroundId }]"
             :ref="'color-' + o.flossId">
            <div ><img :alt="o.backgroundImageName"
     :src="o.backgroundImageUrl" /></div>
            <label>
                {{  o.backgroundImageName }}

        </label>
    </div>
    </div>
</template>

<script>
    export default {
        name: "BackgroundImages",
        data() {
            return {
                selectedbackgroundId: Number,
            };
        },
        props: {
            backgroundImageId: Number,
            productInfo: Object,
        },
        methods: {
            changeBackgroundImage(biId, biFile) {
                this.$emit("change-background-image", biId, biFile);
            },
        },
        computed: {},
        mounted: function () {
            this.selectedbackgroundId = this.backgroundImageId;
        },
        components: {},
    };
</script>
<style>
    .background-images {
        display: flex;
        margin: 1em;
        gap: .5em;
        flex-wrap: wrap;
        height: unset;
        flex-direction:row;
    }

    .background-image {
        cursor: pointer;
        /* min-width: 3em; */
        width: calc(16.667% - .44em);
    }

        .background-image:hover > div {
            outline-color: #666;
        }

        .background-image.selected > div {
            outline-color: #666;
        }

        .background-image > div {
            overflow: hidden;
            position: relative;
            /* overflow: hidden; */
            height: 2.5em;
            border-radius: 2px;
            border: solid 1px #fff;
            outline: solid 1px #ccc;
        }

            .background-image > div > img {
                height: 100%;
                -ms-interpolation-mode: nearest-neighbor;
                image-rendering: -moz-crisp-edges;
                image-rendering: pixelated;
                max-width: none;
            }

            @media only screen and (max-width: 750px) {
                .background-image {
            max-width: unset;
        }
    }

    .background-image label {
        display: none;
    }

    .backgound-image:hover label {
        font-size: 0.7rem;
        padding: 0.5em 0 0;
        width: calc(100% + 4em);
        line-height: 1.15em;
        /* white-space: nowrap; */
        /* border: solid 1px; */
        text-align: center;
        position: absolute;
        left: 50%;
        top: 4.25em;
        transform: translateX(-50%);
        /*display: block;*/
        /* border: solid 1px; */
    }

    .backgound-image:hover label {
        color: #b1b0a5;
    }
</style>
